<template>
  <div class="instructions">
    <div v-if="$route.params.page == 1">
      <div class="instructionText">
        <p>For each turn there will be a sequence of two pictures of black and white lines. One picture will be displayed briefly, followed by another. For instance, you may see:</p>
      </div>
      <div class="demo_sequence">
        <div class="d-flex m-3">
          <div class="p-2 flex-fill align-self-center">
            <p class="emptyText">dddd</p>
            <img class="img-fluid" :src="getACue" />
          </div>
          <div class="p-2 flex-fill align-self-center">...followed&nbsp;by...</div>
          <div class="p-2 flex-fill align-self-center">
            <p class="emptyText">dddd</p>
            <img class="img-fluid" :src="getXProbe" />
          </div>
        </div>
        <button
          type="button"
          name="nextInstructions"
          class="btn btn-primary btn-next"
          @click="next()"
        >Next</button>
      </div>
    </div>
    <div v-if="$route.params.page == 2">
      <div class="instructionText">
        <p>Your job is to press an arrow key for each picture as quickly and accurately as possible.</p>
        <p>
          For the first picture, always press the
          <strong>left</strong> arrow key.
        </p>
        <p>
          For the second picture, press the
          <strong>up</strong> arrow if it completes the correct sequence. Press the
          <strong>right</strong> arrow if it does not complete the sequence.
        </p>
        <p>The correct sequence is shown below.</p>
      </div>
      <div class="demo_sequence">
        <div class="d-flex m-3">
          <div class="p-2 flex-fill align-self-center">
            <center><p class="emptyText">dddd</p></center>
            <img class="img-fluid" :src="getACue" />
          </div>
          <div class="p-2 flex-fill align-self-center">...followed&nbsp;by...</div>
          <div class="p-2 flex-fill align-self-center">
            <center><p class="emptyText">dddd</p></center>
            <img class="img-fluid" :src="getXProbe" />
          </div>
        </div>
        <button
          type="button"
          name="previousInstructions"
          class="btn btn-secondary"
          @click="previous()"
        >Previous</button>
        <button
          type="button"
          name="nextInstructions"
          class="btn btn-primary btn-next"
          @click="next()"
        >Next</button>
      </div>
    </div>

    <div v-if="$route.params.page == 3">
      <div class="instructionText">
        <p><b>Pay attention to the angle and the width of the lines. </b> Remember, the correct sequence looks like this:</p>
      </div>
      <div class="demo_sequence">
        <div class="d-flex m-3">
          <div class="p-2 flex-fill align-self-center">
            <p class="correctText">CORRECT</p>
            <img class="img-fluid" :src="getACue" />
          </div>
          <div class="p-2 flex-fill align-self-center">...followed&nbsp;by...</div>
          <div class="p-2 flex-fill align-self-center">
            <p class="correctText">CORRECT</p>
            <img class="img-fluid" :src="getXProbe" />
          </div>
        </div>
        <button
          type="button"
          name="previousInstructions"
          class="btn btn-secondary"
          @click="previous()"
        >Previous</button>
        <button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="next()"
        >Next</button>
      </div>
    </div>

    <div v-if="$route.params.page == 31">
        <div class="instructionText">
          <p>So, for example, an incorrect sequence could look like this:</p>
        </div>
        <div class="demo_sequence">
          <div class="d-flex m-3">
            <div class="p-2 flex-fill align-self-center">
              <p class="incorrectText">INCORRECT</p>
              <img class="img-fluid" :src="getIncorrectBCue" />
            </div>
            <div class="p-2 flex-fill align-self-center">...followed&nbsp;by...</div>
            <div class="p-2 flex-fill align-self-center">
              <p class="correctText">CORRECT</p>
              <img class="img-fluid" :src="getXProbe" />
            </div>
          </div>
          <button
            type="button"
            name="previousInstructions"
            class="btn btn-secondary"
            @click="previous()"
          >Previous</button>
          <button
            type="button"
            name="endInstructions"
            class="btn btn-primary btn-next"
            @click="next()"
          >Next</button>
        </div>
    </div>

    <div v-if="$route.params.page == 32">
      <div class="instructionText">
        <p>Again, the correct sequence looks like this:</p>
      </div>
      <div class="demo_sequence">
        <div class="d-flex m-3">
          <div class="p-2 flex-fill align-self-center">
            <p class="correctText">CORRECT</p>
            <img class="img-fluid" :src="getACue" />
          </div>
          <div class="p-2 flex-fill align-self-center">...followed&nbsp;by...</div>
          <div class="p-2 flex-fill align-self-center">
            <p class="correctText">CORRECT</p>
            <img class="img-fluid" :src="getXProbe" />
          </div>
        </div>
        <button
          type="button"
          name="previousInstructions"
          class="btn btn-secondary"
          @click="previous()"
        >Previous</button>
        <button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="next()"
        >Next</button>
      </div>
    </div>

    <div v-if="$route.params.page == 33">
      <div class="instructionText">
          <p>So another incorrect sequence could look like this:</p>
      </div>
      <div class="demo_sequence">
        <div class="d-flex m-3">
          <div class="p-2 flex-fill align-self-center">
            <p class="correctText">CORRECT</p>
            <img class="img-fluid" :src="getACue" />
          </div>
          <div class="p-2 flex-fill align-self-center">...followed&nbsp;by...</div>
          <div class="p-2 flex-fill align-self-center">
            <p class="incorrectText">INCORRECT</p>
            <img class="img-fluid" :src="getIncorrectYProbe" />
          </div>
        </div>
        <button
          type="button"
          name="previousInstructions"
          class="btn btn-secondary"
          @click="previous()"
        >Previous</button>
        <button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="goToTrainingPage()"
        >Next</button>
      </div>
    </div>

    <div v-if="$route.params.page == 14">
      <div class="instructionText">
        <br />
        <br />
        <h4>
          You will do the task twice with a brief break in between.
          <br />Remember to answer as quickly and accurately as possible.
        </h4>
      </div>
      <div class="demo_sequence">
        <button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="next()"
        >Next</button>
      </div>
    </div>


    <div v-if="$route.params.page == 6">
      <div class="instructionText">
        <p>
        Now you’ll practice the task at real speed. 
        </p>
        <p>Please keep your eyes focused on the + sign
          in the center of the screen throughout the practice. Answer as quickly and accurately as possible.
        </p>
      </div>
      <div class="demo_sequence">
        <button
          type="button"
          name="previousInstructions"
          class="btn btn-secondary"
          @click="goToTrainingPage()"
        >Previous</button>
        <button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="nextInstruction()"
        >Start Practice</button>
        <br><br>
        <!-- button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="nextInstruction()"
        >Start Practice</button>
        <br><br -->
        <!-- button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="skipInstruction()"
        >Skip Practice</button -->
      </div>
    </div>
    <div v-if="$route.params.page == 5">
      <div class="instructionText">
        <br />
        <br />
        <h4>Practice round complete!
        </h4>
      </div>
      <div class="demo_sequence">
        <button
          type="button"
          name="endInstructions"
          class="btn btn-secondary"
          @click="nextInstruction()"
        >Repeat Practice</button>
        <button
          type="button"
          name="endInstructions"
          class="btn btn-primary btn-next"
          @click="next()"
        >Next</button>
      </div>
    </div>



  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import State from '../mixins/State'
export default {
  mixins: [State],
  computed: {
    ...mapGetters(['getACue', 'getXProbe', 'getIncorrectBCue', 'getIncorrectYProbe'])
  },
  methods: {
    ...mapActions(['restart_training']),
    next () {
      // go to next page of the instructions
      switch (parseInt(this.$route.params.page, 10)) {
        case 5:
          this.$router.replace('/block')
          break
        case 2:
          this.$router.replace('/instructions/3')
          break
        case 3:
          this.$router.replace('/instructions/31')
          break
        case 31:
          this.$router.replace('/instructions/32')
          break
        case 32:
          this.$router.replace('/instructions/33')
          break
        case 33:
          this.$router.replace('/instructions/4')
          break
        case 4:
          this.$router.replace('/instructions/6')
          break
        default:
          this.$router.replace('/instructions/2')
          break
      }
    },
    previous () {
      // go to the previous page of instructions
      switch (parseInt(this.$route.params.page, 10)) {
        case 3:
          this.$router.replace('/instructions/2')
          break
        case 31:
          this.$router.replace('/instructions/3')
          break
        case 32:
          this.$router.replace('/instructions/31')
          break
        case 33:
          this.$router.replace('/instructions/32')
          break
        case 4:
            this.$router.replace('/instructions/33')
            break
        case 5:
            this.$router.replace('/instructions/4')
            break
        case 6:
            this.$router.replace('/instructions/4')
            break
        default:
          this.$router.replace('/instructions/1')
          break
      }
    },
    goToTrainingPage () {
      // go to the training page
      this.$router.replace("/training");
    },
    nextInstruction () {
      // go to the training page
      // this.$router.replace("/training");
      // this.restart_training()
      // this.$router.replace("/training_cue")
      // insert a blank page for two seconds so participants can ready themselv
      this.restart_training()
      this.$router.replace("/blank_page/training")
    },
  }
}
</script>

<style scoped>
.container {
  height: 30vh;
  width: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row {
  display: flex;
}
.instructions {
  font-size: 24px;
}
.instructionText {
  height: 22vh;
}
.demo_sequence {
  position: absolute;
  top: 35%;
  margin: auto;
  width: 836px;
}
.correctText {
  color: green;
  border-style: double;
  text-align: center;
  background-color: white;
}
.incorrectText {
  color: red;
  border-style: double;
  text-align: center;
  background-color: white;
}
.emptyText {
  color: gray;
}
.btn-next {
  float: right;
}
</style>
